import LatestEvent from "./LatestEvent";
export default LatestEvent;
